import { render } from "./paysage.vue?vue&type=template&id=04cb0c4f&scoped=true"
import script from "./paysage.vue?vue&type=script&lang=js"
export * from "./paysage.vue?vue&type=script&lang=js"

import "./paysage.vue?vue&type=style&index=0&id=04cb0c4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cb0c4f"]])

export default __exports__